import { Component, inject } from '@angular/core';

import { UntilDestroy } from '@ngneat/until-destroy';

import { CoreService } from '../../../core/core.service';
import { EnvironmentService } from '../../../core/environment.service';
import { DashboardService } from '../../shared/services/dashboard.service';

export enum StatisticDetailEnum {
    RECIPE = 'RECIPE',
    PURCHASE = 'PURCHASE',
}

@UntilDestroy()
@Component({
    selector: 'oc-statistic-overview',
    templateUrl: './overview.component.html',
    styleUrls: ['./overview.component.css'],
    standalone: false,
})
export class OverviewComponent {
    protected readonly coreService = inject(CoreService);
    private readonly environmentService = inject(EnvironmentService);
    private readonly dashboardService = inject(DashboardService);

    showRecipeStatistics: boolean = false;
    showPurchaseStatistics: boolean = false;

    onShowRecipeStatistics() {
        this.showDetail(StatisticDetailEnum.RECIPE);
    }
    onShowPurchaseStatistics() {
        this.showDetail(StatisticDetailEnum.PURCHASE);
    }
    showDetail(what: string) {
        switch (what) {
            case StatisticDetailEnum.RECIPE:
                this.showRecipeStatistics = true;
                this.showPurchaseStatistics = false;
                break;
            case StatisticDetailEnum.PURCHASE:
                this.showRecipeStatistics = false;
                this.showPurchaseStatistics = true;
                break;
        }
    }
    // openRecipeStatistics() {
    //     const token = this.environmentService.systemUser?.token;
    //     const url = this.environmentService.ctxrootDashboard + `/app/#rezepturen&token=${token}`;
    //     window.open(url, '_blank');
    // }
    // 1. Hidden Form POST (einfachste Verbesserung)
    // Token wird nicht in der Adressleiste / Browser-History sichtbar:
    openRecipeStatistics() {
        this.dashboardService.navigateToDashboard('#rezepturauswertung');
    }
    // 2. window.postMessage (sauberste Client-Lösung)
    // Tab wird leer geöffnet, Token wird nachträglich sicher übermittelt:
    // Das Dashboard muss window.addEventListener('message', ...) implementieren.
    // SRK: Wird wahrscheinlich nicht BrowserTAB übergreifend funktionieren, insbesondere bei Cross-Origin
    // openRecipeStatistics() {
    //     const token = this.environmentService.systemUser?.token;
    //     const newTab = window.open('https://01.dashboards.mws-dev-01.d.orgacard.de/app/#rezepturen', '_blank');
    //     const newTab = window.open(this.environmentService.ctxrootDashboard + '/app/#rezepturen', '_blank');
    //     newTab?.addEventListener('load', () => {
    //         newTab.postMessage({ token }, 'https://01.dashboards.mws-dev-01.d.orgacard.de');
    //     });
    // }
    // 3.  One-Time-Token vom Backend (sicherste Lösung)
    // Backend tauscht den Session-Token gegen ein kurzlebiges Einmal-Token:
    // Token verfällt nach einmaligem Gebrauch – selbst wenn er in der URL sichtbar ist, ist er wertlos.
    // openRecipeStatistics() {
    //     this.statisticService.getOneTimeToken().subscribe(oneTimeToken => {
    //         window.open(`https://01.dashboards.mws-dev-01.d.orgacard.de/app/#rezepturen&token=${oneTimeToken}`, '_blank');
    //     });
    // }

    openPurchaseStatistics() {
        this.dashboardService.navigateToDashboard('#einkaufsauswertung');
    }
}
